import React from 'react'
import { formatTimeDiff } from './MessagingProvider'
import parse from 'html-react-parser'

const CoachMessage = ({ message, coach, candidateName }) => {
  const {
    coach_is_sender: coachIsSender,
    body,
    created_at: createdAt,
    attachment: { url: attachmentUrl },
    attachment_filename: attachmentFilename,
  } = message || {}
  const {
    full_name: coachName,
    photo_preview_url: coachPhotoUrl,
    transparent_photo_preview_url: coachTransparentPhotoUrl,
  } = coach || {}
  const photoUrl = coachTransparentPhotoUrl || coachPhotoUrl
  const senderName = coachIsSender ? coachName : candidateName

  const containerClass =
    'mb-4 scroll-mb-4 pb-4 border-b border-silver last:border-b-0'

  return (
    <div className={containerClass}>
      <div className="flex flex-col gap-4">
        <div className="flex flex-row items-center justify-start">
          {coachIsSender && photoUrl && (
            <div className="mr-2 flex h-12 w-12 items-center justify-center rounded-full bg-willow-brook">
              <img src={photoUrl} alt="Coach Photo" className="max-h-6" />
            </div>
          )}
          <div className="text-xl font-medium">{senderName}</div>
        </div>
        <div className="[&_P]:break-words [&_P]:text-left">
          {parse(body.replace(/&nbsp;/g, ' '))}
          {attachmentUrl && (
            <a
              rel="noreferrer"
              href={attachmentUrl}
              className="my-2 inline-block"
              download
            >
              {attachmentFilename}
            </a>
          )}
        </div>
        <div>{formatTimeDiff(createdAt)}</div>
      </div>
    </div>
  )
}
export default CoachMessage
